export default __webpack_public_path__ + "img/img05.0d732af3.png";